import { render, staticRenderFns } from "./data36.vue?vue&type=template&id=10b2ffda&scoped=true&"
import script from "./data36.vue?vue&type=script&lang=js&"
export * from "./data36.vue?vue&type=script&lang=js&"
import style1 from "./data36.vue?vue&type=style&index=1&id=10b2ffda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2ffda",
  null
  
)

export default component.exports